export default {
  title: 'Fees',
  subtitle: 'Per-restaurant service fee override for {{company}}.',
  card_title: 'Service fee',
  banner: {
    default_summary: 'Partner default: {{percentage}}% · min {{min}} · max {{max}}.',
    override_hint: 'Override below to set a different fee for this restaurant.',
    suggested_summary: 'Suggested starting values: {{percentage}}% · min {{min}} · max {{max}}.',
    suggested_hint: 'Adjust them below and save to charge a service fee at this restaurant.',
    own_fee_hint: 'This restaurant charges its own fee, set below.',
    saved_summary: 'Your last saved values: {{percentage}}% · min {{min}} · max {{max}}.',
    saved_hint: 'The service fee is off. Save these, or change them first, to turn it back on.',
  },
  form: {
    recommended: 'Recommended: {{value}}',
    percentage: {
      label: 'Service fee percentage',
      tooltip: 'Percentage of the order value charged to the diner as a service fee.',
    },
    min_amount: {
      label: 'Minimum service fee amount',
      tooltip: 'Computed fees below this amount are rounded up to it.',
    },
    max_amount: {
      label: 'Maximum service fee amount',
      tooltip: 'The service fee never exceeds this amount, regardless of the order value.',
    },
  },
  limits:
    'Must stay within FoodAmigos limits: max {{max_percentage}}% / {{max_amount}}, minimum at least {{min_amount}}.',
  not_charged_notice: 'No service fee is charged at this restaurant right now. Save a fee below to turn it on.',
  zero_percentage_warning:
    'A 0% percentage does not disable the service fee: computed fees below the minimum amount are rounded up to it, so every order is still charged at least the minimum.',
  buttons: {
    edit: 'Edit',
    cancel: 'Cancel',
    save: 'Save',
    reset_to_default: 'Reset to partner default',
    turn_off: 'Turn off service fee',
  },
  toasts: {
    load_error: 'Could not load the service fee settings.',
    failed_to_save_changes: 'Failed to save changes',
    changes_got_saved: 'Changes got saved',
    reset_to_default: 'Override removed — the partner default applies.',
    reset_to_default_skipped: 'Override removed — no service fee is charged until you save one.',
    turned_off: 'Service fee turned off. Your values are kept for when you turn it back on.',
  },
};
